<template>
    <div>
        <nav-bar></nav-bar>
        <div class="content">
            <nav-left-bar :active="0"></nav-left-bar>
            <div class="rg">
                <div class="tit">
                    <img src="../../assets/icon/bg.png" alt="" />
                    <div class="tc">会议室预约审批记录</div>
                </div>
                <div class="bot">
                    <div class="list">
                        <div
                            :class="type == 1 ? 'one active' : 'one'"
                            @click="choose(1)"
                        >
                            待审批
                        </div>
                        <div
                            :class="type == 1 || type == 2 ? '' : 'line'"
                        ></div>
                        <div
                            :class="type == 2 ? 'one active' : 'one'"
                            @click="choose(2)"
                        >
                            审批中
                        </div>
                        <div
                            :class="type == 2 || type == 3 ? '' : 'line'"
                        ></div>
                        <div
                            :class="type == 3 ? 'one active' : 'one'"
                            @click="choose(3)"
                        >
                            审批完成
                        </div>
                    </div>
                    <div class="data-list">
                        <div class="li">
                            <div class="title"></div>
                        </div>
                    </div>
                </div>
                <div class="list-in">
                    <div class="lis" v-for="(item,index) in sourceList" :key="index"  @click="look(item.id)">
                        <div class="title">{{item.name}}</div>
                        <div class="address">{{item.address}}</div>
                        <div class="con">{{item.theme}}</div>
                    </div>
                     <div class="no-more" v-if="sourceList.length == 0">
                        <img :src="$global.Image.noMore" alt="" />
                        <div>暂无数据~</div>
                    </div>
                </div>
                <div class="bo" >
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        :page-size="12"
                        @current-change="currentPage"
                        @prev-click="prev"
                        @next-click="next" v-if="sourceList.length != 0"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "room_approval",
    data() {
        return {
            type:'1',
             page: 1,
            limit: 12,
            sourceList: [],
            show: false,
            total:0
        };
    },
    methods: {
         choose(e) {
            this.type = e;
            this.list();
        },
        look(e){
            this.$router.push({
                path:'/room_approvalDetails',
                query:{
                    id:e,
                    type:this.type
                }
            })
        },
        list() {
            let params = {
                page: this.page,
                limit: this.limit,
                type: this.type
            };
            this.$post("/api/person/my_meeting_approval_list", params)
                .then(res => {
                    if (res.code == 1) {
                        this.sourceList = res.data.data;
                        this.total=res.data.count;
                        if (res.data.data.length < this.limit) {
                            this.show = true;
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        currentPage(e) {
            this.page = e;
            this.list();
        },
        next(e) {
            this.page = e;
            this.list();
        },
        prev(e) {
            this.page = e;
            this.list();
        }
    },
    mounted(){
        this.list()
    }
};
</script>
<style lang="less" scoped>
.content {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 21px;
    display: flex;
    .rg {
        width: 838px;
        height: 56px;
        // line-height: 80px;
        background: #ffffff;
        margin-left: 21px;
        padding-top: 24px;
        .tit {
            width: 100%;
            display: flex;
            align-items: center;
            img {
                width: 5px;
                height: 24px;
            }
            .tc {
                font-size: 24px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                color: #333333;
                padding-left: 13px;
            }
        }
        .bot {
            width: 838px;
            height: auto;
            margin-top: 45px;
            .list {
                display: flex;
                width: 100%;
                height: 60px;
                line-height: 60px;
                align-items: center;
                background: #ffffff;
                border-bottom: 1px solid #3449d3;
                .one {
                    width: 142px;
                    height: 100%;
                    color: #3449d3;
                    font-size: 18px;
                    text-align: center;
                    cursor: pointer;
                }
                .line {
                    background: #3449d3;
                    width: 1px;
                    height: 30px;
                }
                .active {
                    color: #ffffff;
                    background: #3449d3;
                }
            }
        }
        .list-in {
            width: 838px;
            min-height: 400px;
            background: #ffffff;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            padding-bottom: 100px;
            .lis {
                padding-left: 19px;
                display: flex;
                width: 327px;
                height: 116px;
                background: url("../../assets/icon/icon_bg_yy.png") no-repeat;
                background-size: 100% 100%;
                flex-direction: column;
                justify-content: center;
                margin-left: 45px;
                margin-top: 45px;
                cursor: pointer;
                .title {
                    width: 327px;
                    font-size: 16px;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    text-align: left;
                    color: #333333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .address {
                    width: 327px;
                    font-size: 13px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: #666666;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    padding: 10px 0 15px 0;
                }
                .con {
                    width: 327px;
                    color: #3449d3;
                    font-size: 18px;
                    text-align: left;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>
